import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  getChangeEvent,
  transformFromNumberToString,
  transformFromStringToNumber,
} from 'components/modules/Insurance/Insurance.helpers';
import { insuranceSetError, setBatchState } from 'store/insuranceCalculation';
import { FIELDS } from 'store/insuranceCalculation/constants';
import { selectErrors, selectInsuranceCalculation } from 'store/insuranceCalculation/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

export const useMultidriveFormPresenter = () => {
  const dispatch = useDispatch();

  const errors = useSelector(selectErrors);
  const {
    [FIELDS.MIN_DRIVERS_AGE]: minDriversAge,
    [FIELDS.MIN_DRIVERS_EXPERIENCE]: minDriversExperience,
  } = useSelector(selectInsuranceCalculation);

  const { disabled: pageRestrict } = useDisabledFields();

  const onChange = useCallback(
    (event) => {
      const { key, value } = getChangeEvent(event);

      dispatch(setBatchState({ [key]: value && transformFromStringToNumber(value) }));
      dispatch(insuranceSetError({ key, value: '' }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    disabled: pageRestrict,
    errors,
    onChange,
    values: {
      [FIELDS.MIN_DRIVERS_AGE]: transformFromNumberToString(minDriversAge),
      [FIELDS.MIN_DRIVERS_EXPERIENCE]: transformFromNumberToString(minDriversExperience),
    },
  };
};
